import _regeneratorRuntime from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

import * as tslib_1 from "tslib";
import axios from 'axios';
export var getAxiosClient = function getAxiosClient(config) {
  var headers = Object.assign({
    Authorization: config.authToken || undefined,
    Accept: 'application/json'
  }, config.headers || {});
  var client = axios.create({
    baseURL: config.url,
    headers: headers
  });
  return client;
};
export var getHttpProvider = function getHttpProvider(axios, config) {
  var log = function log(value) {
    return axios.post(config.logEndpoint || 'log', value).then(function (cv) {
      return cv.status === 200 ? true : false;
    });
  };

  var get = function get(key) {
    return axios.get(key).then(function (cv) {
      return cv.data;
    });
  };

  var post = axios.post;

  var save = function save(key, value) {
    return post(key, value).then(function (cv) {
      return cv.data;
    });
  };

  var update = function update(key, value) {
    return axios.patch(key, value).then(function (cv) {
      return cv.data;
    });
  };

  var del = function del(key) {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return axios.delete(key);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };

  var httpProvider = {
    kind: 'http',
    update: update,
    save: save,
    get: get,
    delete: del,
    log: log,
    post: post
  };
  return httpProvider;
};
export var HttpProvider = function HttpProvider(axios, config) {
  return getHttpProvider(axios, config);
};